import React from "react";

import { DetailedHTMLProps } from "react";
import { HTMLAttributes } from "react";

import clsx from "clsx";

import SiteReviews from "@js/component/SiteReviews";


import * as classNames from "@css/component/TopBar.module.scss";

/**
 * @type TopBarProps
 */
export type TopBarProps = Omit<DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>, "children">;

/**
 * @const TopBar
 */
const TopBar = (props: TopBarProps) => {
    const {
        className,
        ...restProps
    } = props;

    const onMailTo = () => {
        typeof window == "object" && window.gtag && window.gtag("event", "mailto_click");
    };

    return (
        <div { ...restProps } className={ clsx(classNames.topBar, className) }>
            <div className={ classNames.container }>
                <span className={ classNames.text }>
                    De meest complete onafhankelijke vergelijker, sinds 2021.
                </span>
                <SiteReviews className={classNames.reviewComponent}/>
            </div>
        </div>
    );
};

export default TopBar;
